import { AccordionSummary, Box, makeStyles } from '@material-ui/core';
import React from 'react';

import { useCustomTheme } from '@/hooks/useCustomTheme';

export function AccordionProgressSummary(props: { children: React.ReactNode; expanded: boolean; hideIcon?: boolean }) {
  const { customBorderRadius } = useCustomTheme();

  const useStyles = makeStyles({
    root: {
      '&:hover': { cursor: 'unset !important' },
      minHeight: '24px !important',
      borderRadius: customBorderRadius.paper,
      '& .MuiAccordionSummary-content': {
        margin: '0 !important',
        padding: '0px 8px',
        display: 'inline-flex',
        justifyContent: 'space-between',
        width: '100%',
      },
    },
  });

  return (
    <AccordionSummary className={useStyles().root} style={{ padding: 0, minHeight: '0 !important' }}>
      {props.children}
      {!props.hideIcon && (
        <Box display={'flex'} justifyContent={'center'} flexDirection={'column'} ml={2}>
          <i className="material-icons-outlined" style={{ fontSize: '16px' }}>
            {props.expanded ? 'expand_less' : 'expand_more'}
          </i>
        </Box>
      )}
    </AccordionSummary>
  );
}
